import { DateValueObject } from '@/utils/value-objects/date/date-value-object.js';

export class ProbeEventStartedAt extends DateValueObject {}
